import React from 'react';

const PlainStarIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.62402 5.85449L9.68652 6.00195L9.84668 6.0166L14.0186 6.37793L10.8613 9.11621L10.7402 9.2207L10.7764 9.37695L11.7168 13.4463L8.14062 11.2891L8.00293 11.2061L7.86523 11.2891L4.28711 13.4463L5.22949 9.37695L5.26562 9.2207L5.14355 9.11621L1.98633 6.37793L6.15918 6.0166L6.31934 6.00195L6.38184 5.85449L8.00195 2.01855L9.62402 5.85449Z'
        stroke='currentColor'
        strokeWidth='0.533333'
      />
    </svg>
  );
};

export default PlainStarIcon;
